import { render } from "./Logged.vue?vue&type=template&id=86503ea8"
import script from "./Logged.vue?vue&type=script&lang=js"
export * from "./Logged.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__